import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import InputSelect from '../../../Core/InputSelect'
import { PaperClipIcon, TrashIcon, UploadIcon } from '../../Icons'

const documentTypes = [
  {
    id: 'manual',
    name: 'Manual',
  }, {
    id: 'invoice',
    name: 'Invoice',
  }, {
    id: 'warranty',
    name: 'Warranty',
  }, {
    id: 'certificate',
    name: 'Certificate',
  }, {
    id: 'rental_document',
    name: 'Rental Document',
  }, {
    id: 'maintenance_document',
    name: 'Maintenance Document',
  }, {
    id: 'inspection_document',
    name: 'Inspection Document',
  }, {
    id: 'photo',
    name: 'Photo',
  }, {
    id: 'other',
    name: 'Other',
  }
]

const AssetDocumentsUpload = ({documents, onChange}) => {
  const { t } = useTranslation()

  const [documentType, setDocumentType] = useState('manual')

  const uploadInputRef = useRef(null)

  const handleChangeType = (e) => {
    const { value } = e.target
    setDocumentType(value)
  }

  const handleChangeFile = (e) => {
    const files = e.target.files
    if (files.length > 0) {
      const newDocuments = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        newDocuments.push({
          file,
          type: documentType,
        })
      }
      
      onChange([...documents, ...newDocuments])
    }
  }

  const handleRemove = (index) => () => {
    const newDocuments = [...documents]
    newDocuments.splice(index, 1)
    onChange(newDocuments)
  }

  return (
    <div className={styles.container}>
      <div className={styles.documentsList}>
        {
          documents.map((doc, i) => {
            return (
              <div key={i} className={styles.documentItem}>
                <PaperClipIcon />
                <span className={styles.documentName}>{doc.name || doc.file?.name}</span>
                <span className={styles.documentType}>{doc.type}</span>
                <button type="button" className={styles.removeButton} onClick={handleRemove(i)}>
                  <TrashIcon width={14} height={14} />
                </button>
              </div>
            )
          })
        }
      </div>
      <div className={styles.uploadSection}>
        <input type="file" style={{display: 'none'}} multiple={true} ref={uploadInputRef} onChange={handleChangeFile} />
        <button type="button" className={styles.addDocumentButton} onClick={() => uploadInputRef.current.click()}>
          <UploadIcon />
          { t('Upload document') }
        </button>
        <InputSelect
          id='document_type'
          options={documentTypes}
          value={documentType}
          name='document_type'
          onChange={handleChangeType}
          valueKey='id'
          labelKey='name'
          className={styles.documentTypeSelect}
          // error={errors.customer_id}
        />
      </div>
    </div>
  )
}

export default AssetDocumentsUpload
